import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./protected";
import React from "react";
import { SidebarProvider } from "../context/sidebar";

const Layout = React.lazy(() => import("../layouts"));
const Dashboard = React.lazy(() => import("../pages/dashboard"));
const Forms = React.lazy(() => import("../pages/forms"));
const StaffPage = React.lazy(() => import("../pages/staff"));
const DecisionLetterPage = React.lazy(() => import("../pages/decisionLetter"));
const JobOpeningPage = React.lazy(() => import("../pages/jobOpenings"));
const JobOpeningCreatePage = React.lazy(() => import("../pages/jobOpenings/create"));
const JobOpeningEditPage = React.lazy(() => import("../pages/jobOpenings/edit/page"));
const Login = React.lazy(() => import("../pages/login"));
const Auth = React.lazy(() => import("../pages/auth"));
const NotFound = React.lazy(() => import("../pages/404"));

const MainRouter = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute
        element={
          <SidebarProvider>
            <Layout />
          </SidebarProvider>
        }
      />
    ),
    children: [
      { index: true, element: <Dashboard />, handle: { name: "Beranda" } },
      { path: "pegawai", element: <StaffPage />, handle: { name: "Pegawai" } },
      { path: "sk", element: <DecisionLetterPage />, handle: { name: "Surat Keputusan" } },
      { path: "forms", element: <Forms />, handle: { name: "Formulir" } },
      {
        path: "lowongan-kerja",
        handle: { name: "Lowongan Kerja" },
        children: [
          {
            index: true,
            element: <JobOpeningPage />,
            handle: { name: "Daftar" },
          },
          {
            path: "buat",
            element: <JobOpeningCreatePage />,
            handle: { name: "Buat" },
          },
          {
            path: "edit/:id",
            element: <JobOpeningEditPage />,
            handle: { name: "Edit" },
          }
        ]
      }
      // {
      //   path: "master",
      //   element: <></>,
      //   handle: { name: "Master" },
      //   children: [
      //     {
      //       path: "goods",
      //       element: <>barang</>,
      //       handle: { name: "Barang" },
      //       children: [
      //         {
      //           path: "forms",
      //           element: <>barang</>,
      //           handle: { name: "form" },
      //         },
      //         { path: "add", element: <>barang</>, handle: { name: "add" } },
      //       ],
      //     },
      //   ],
      // },
    ],
  },
  { path: "/login", element: <Login />, handle: { name: "Login" } },
  { path: "/auth", element: <Auth />, handle: { name:"Auth" }},
  { path: "*", element:<NotFound />, handle: { name: "NotFound"}},
]);

export default MainRouter;
